module.exports = __webpack_public_path__ + "img/rose-7.9c74fb5b.png";